export const OPPORTUNITY_SELECTION = `
    leadSource
    leadType
    leadCode
    processStage
    dealType
    lotId
    lotName
    prospect {
        customerId
        customerCode
        email
        cellPhone
        firstName
        lastName
        language
        allowTextCellPhone
    }
    vehicle {
        stockNumber
        customStockNumber
        vin
        year
        make
        model
        trim
        extColor
        thumbnail
        miles
        stickerPrice
        internetPrice
    }
    availableCash
    vehicleYear
    vehicleMake
    vehicleModel
    vehicleTrim
    vehiclePrice
    tradeVin
    tradeYear
    tradeMake
    tradeModel
    tradeTrim
    tradeMiles
    tradeACV
    tradePayoff
    tradePayoffDate
    tradeLeinHolder
    recordManager
    appointmentDate
    appointmentSalesman
    noDeal
    createdOn
    modifiedOn
    status
    crmId
    recordManagerId
    salespersonId
    reason
    leadSourceId
    obstacleToCloseId
    chosenVehiclePrice
    tags {
        name
        tagId
        color
    }
    sold
    showed
    showedDate
    prospectLeftDate
    demo
    writeUp
    finance
    lastResults
    tradeOffer
`;

export default OPPORTUNITY_SELECTION;
